import { TryScrambleText } from './text-scrambler';
import { getProvinceOrStateCopy } from './province_or_state';
import { standardizedCityName } from 'utils/standardized-city-name';

export default function generateFullAddress(streetAddress: string | null, cityAddress: string | null, provinceAddress: string | null, shouldScramble: boolean) {
  const street = streetAddress ? streetAddress : '';
  const city = cityAddress ? standardizedCityName(cityAddress.toLowerCase()) : '';
  const province = provinceAddress ? getProvinceOrStateCopy(provinceAddress, cityAddress) : '';
  const fullAddress = `${street}${city && ', '+city}${province && ', '+province}`;
  return (
    TryScrambleText(fullAddress, shouldScramble)
  );
}
